/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Appointments API
 * API for managing appointments (afspraken) within an organization. All operations are scoped to the authenticated user\'s organization.  ## Session Types  The API supports four types of sessions:  ### Individual Sessions Standard one-on-one appointments with a single client and behandelaar. Use `clientId` for single client appointments.  ### Group Sessions (explicit clients) Appointments with multiple clients (e.g., group therapy, family sessions). Use `clientIds` array to specify multiple clients. Each client gets individual attendance tracking and billable quarters calculation.  ### Client Group Sessions (dynamic membership) Appointments linked to a Client Group. The participating clients are determined dynamically based on who is a member of the group on the appointment date. Use `groupId` to assign a client group. For recurring appointments, each instance resolves members independently based on its own `startTime`.  When `groupId` is set, the `clientIds` field is ignored (the group determines clients). The response includes: - `group`: Basic group info (id, name) - `participants`: Clients who are members of the group on the appointment date   (each entry carries `clientId`, `clientName`, and membership dates)  ### Multidisciplinary Sessions Appointments with multiple behandelaren (e.g., MDO - multidisciplinair overleg). Use `attendeeIds` array to add additional behandelaren beyond the primary `behandelaarId` (who becomes the organizer).  ### Internal Meetings Team meetings without clients. Use `category: \"INTERNAL\"` and omit client fields.  ## All-Day Appointments  All-day appointments (e.g., daily stay costs in residential care) span the entire day. Set `isAllDay: true` to create an all-day appointment. When `isAllDay` is true: - `startTime` should be set to the start of the day (00:00 / midnight) - `endTime` should be set to the end of the same day (23:59) - `durationMinutes` reads 1439 — the span is 00:00:00.000 through 23:59:59.999,   and the response derives the duration from those two times rather than storing it  All-day appointments are backwards compatible: existing appointments default to `isAllDay: false`. Note: multi-day appointments (spanning multiple days) are not currently supported.  ## Billable Quarters  For group sessions, each client\'s attendance is tracked individually: - `scheduledStartTime` / `scheduledEndTime` - copied from appointment - `actualStartTime` / `actualEndTime` - set during attendance registration - `billableQuarters` - auto-calculated as ceil(actualMinutes / 15)  Integrates with FullCalendar for calendar UI (see ADR-006). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { RequestArgs } from "./base";
import type { AxiosInstance, AxiosResponse } from 'axios';
import { RequiredError } from "./base";

export const DUMMY_BASE_URL = 'https://example.com'

/**
 *
 * @throws {RequiredError}
 */
export const assertParamExists = function (functionName: string, paramName: string, paramValue: unknown) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
}

export const setApiKeyToObject = async function (object: any, keyParamName: string, configuration?: Configuration) {
    if (configuration && configuration.apiKey) {
        const localVarApiKeyValue = typeof configuration.apiKey === 'function'
            ? await configuration.apiKey(keyParamName)
            : await configuration.apiKey;
        object[keyParamName] = localVarApiKeyValue;
    }
}

export const setBasicAuthToObject = function (object: any, configuration?: Configuration) {
    if (configuration && (configuration.username || configuration.password)) {
        object["auth"] = { username: configuration.username, password: configuration.password };
    }
}

export const setBearerAuthToObject = async function (object: any, configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
}

export const setOAuthToObject = async function (object: any, name: string, scopes: string[], configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken(name, scopes)
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + localVarAccessTokenValue;
    }
}


function setFlattenedQueryParams(urlSearchParams: URLSearchParams, parameter: any, key: string = ""): void {
    if (parameter == null) return;
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            (parameter as any[]).forEach(item => setFlattenedQueryParams(urlSearchParams, item, key));
        }
        else {
            Object.keys(parameter).forEach(currentKey =>
                setFlattenedQueryParams(urlSearchParams, parameter[currentKey], `${key}${key !== '' ? '.' : ''}${currentKey}`)
            );
        }
    }
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        }
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}

export const setSearchParams = function (url: URL, ...objects: any[]) {
    const searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
}

export const serializeDataIfNeeded = function (value: any, requestOptions: any, configuration?: Configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
}

export const toPathString = function (url: URL) {
    return url.pathname + url.search + url.hash
}

export const createRequestFunction = function (axiosArgs: RequestArgs, globalAxios: AxiosInstance, BASE_PATH: string, configuration?: Configuration) {
    return <T = unknown, R = AxiosResponse<T>>(axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...axiosArgs.options, url: (axios.defaults.baseURL ? '' : configuration?.basePath ?? basePath) + axiosArgs.url};
        return axios.request<T, R>(axiosRequestArgs);
    };
}
